import { cutToast } from 'utility/toast';
import { Checkbox, Stack, TextField } from '@fluentui/react';
import { Chip } from 'common/components/Chip';
import { FutureDatePicker } from 'common/components/FutureDatePicker';
import { dateFormat } from 'common/utils/dateFormats';
import { includes } from 'lodash';
import React from 'react';

import { useStyles } from './index.styles';

interface MessageCreateProps {
  onDatesUpdate?: (dates: string[]) => void;
  existingDates?: string[];
  onMessageUpdate?: (message: string) => void;
  onRequestCheck?: (checked: boolean) => void;
}

export const MessageCreate: React.FC<MessageCreateProps> = ({
  onDatesUpdate,
  existingDates,
  onMessageUpdate,
  onRequestCheck,
}) => {
  const styles = useStyles();

  const [selectedDate, setSelectedDate] = React.useState<
    Date | null | undefined
  >(null);

  const onSelectDate = (date: Date | null | undefined): void => {
    if (date) {
      setSelectedDate(date!);
      if (!includes(existingDates, getReminderDateFormat(date!.toString()!))) {
        onDatesUpdate?.([
          ...existingDates!,
          getReminderDateFormat(date!.toString()!),
        ]);
      } else {
        cutToast.error(
          `${dateFormat(
            getReminderDateFormat(date!.toString()!)
          )} is already selected`
        );
      }
    }
  };

  const getReminderDateFormat = (date: string) => new Date(date).toISOString();

  return (
    <Stack
      className={styles.root}
      tokens={{ padding: '0px 25px', childrenGap: 20 }}
    >
      <TextField
        multiline
        rows={10}
        placeholder="Write your message..."
        resizable={false}
        onChange={(_, newValue) => onMessageUpdate?.(newValue!)}
      />

      <Checkbox
        label="Request response"
        onChange={(_, checked) => onRequestCheck?.(checked!)}
      />

      <Stack.Item tokens={{ padding: '20px 0px 0px 0px' }}>
        <FutureDatePicker
          label="Reminder"
          onSelectDate={onSelectDate}
          onValidationError={(error) => {}}
          value={selectedDate!}
        />
      </Stack.Item>

      <Stack horizontal wrap>
        {existingDates?.map((item, index) => {
          return (
            <Stack className={styles.showDates} key={index}>
              <Chip
                onClick={() => {
                  let tempDates: string[] = [...existingDates!];
                  tempDates.splice(tempDates.indexOf(item), 1);
                  onDatesUpdate?.(tempDates);
                }}
                text={dateFormat(item!).toString()}
              />
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};
